import organisation from './organisation';
import admins from './admins';
import agency from './agency';

export default [...admins, ...organisation, ...agency];
